import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './shared/context/AuthContext'
import AppRouter from './shared/router/AppRouter'
import './App.css'

// Import debug utilities
import './shared/utils/debugAuth'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRouter />
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App 